module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_taggs_0a494f3f87c86cb15badb47def818d09.png";